import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { CrudService, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, addPageSpecificationParameters, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { TRANSFER_ASSET_APPROVER_TYPE, TransferAssetApprover } from 'assets-model';
import { Observable } from 'rxjs';



export abstract class TransferAssetApproverServiceBase extends CrudService<TransferAssetApprover, string> {

  servicePath: string = '/transferassetapprover';

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment, TRANSFER_ASSET_APPROVER_TYPE.entityDecorator);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification, reduced: boolean = true): Observable<HateoasMultipleResponseObject<TransferAssetApprover>> {
    var params = appendSerialisedHttpParams(filters);
	
    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
	
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<TransferAssetApprover>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }
}



